import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLetop = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="m8 16 10-8 10 8v16H8z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M16 22h-6v10h6zM28 30a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m14.3 14.4-8 6-.6-.8 8-6zM28.006 12.38a7.5 7.5 0 0 0-5.262 2.063l-.688-.726a8.5 8.5 0 0 1 12.016 12.017l-.724-.688a7.5 7.5 0 0 0-5.342-12.666"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M29.68 26A1.63 1.63 0 0 1 28 27.65a1.639 1.639 0 1 1 0-3.27A1.63 1.63 0 0 1 29.68 26m-3.14-9.35h2.92l-.23 6.79h-2.44z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLetop);

export default ForwardRef;
